const Success = {
  100: '#17A24A',
  90: '#2EAB5C',
  80: '#929498',
  30: '#D6D7D8',
  10: '#E8F6ED',
};

export default Success;
